// Module
var code = "<!-- ko with: _view --> <!-- ko template: {html: GetTemplate, afterRender: AfterRender} --> <!-- /ko --> <!-- /ko -->";
// Exports
export default code;